import { create } from 'zustand';

export const useUIStore = create((set) => ({
  // Navigation
  currentView: 'feed',
  setCurrentView: (view) => set({ currentView: view }),

  // Modals
  showCarousel: false,
  carouselReview: null,
  carouselIndex: 0,
  openCarousel: (review, index) =>
    set({ showCarousel: true, carouselReview: review, carouselIndex: index }),
  closeCarousel: () =>
    set({ showCarousel: false, carouselReview: null, carouselIndex: 0 }),

  showPaymentModal: false,
  paymentData: null,
  openPaymentModal: (creatorId, creatorName, amount) =>
    set({
      showPaymentModal: true,
      paymentData: { creatorId, creatorName, amount },
    }),
  closePaymentModal: () => set({ showPaymentModal: false, paymentData: null }),

  showUnsubscribeModal: false,
  unsubscribeData: null,
  openUnsubscribeModal: (subscriptionId, creatorName, creatorId) =>
    set({
      showUnsubscribeModal: true,
      unsubscribeData: { subscriptionId, creatorName, creatorId },
    }),
  closeUnsubscribeModal: () =>
    set({ showUnsubscribeModal: false, unsubscribeData: null }),

  // Toast
  showToast: false,
  toastMessage: '',
  showToastMessage: (message, duration = 3000) => {
    set({ showToast: true, toastMessage: message });
    setTimeout(() => set({ showToast: false, toastMessage: '' }), duration);
  },

  // Creator Profile
  selectedCreatorId: null,
  reviewFilter: 'all',
  setSelectedCreatorId: (id) => set({ selectedCreatorId: id }),
  setReviewFilter: (filter) => set({ reviewFilter: filter }),
}));
